<template>
    <div class="Welcome">
        <transition @enter="enter" @leave="leave">
            <div ref="container" class="Welcome__container">
                <div class="Welcome__title">MENEATH</div>
                <div>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam fermentum ex arcu, a ultrices enim finibus a. Ut semper et leo ac scelerisque. Pellentesque placerat interdum nisl non faucibus.</div>
                <div class="Welcome__button" @click="onClick()">Continuer</div>
            </div>
        </transition>
    </div>
</template>

<script>

export default {
    name: 'Welcome',
    data: ()=>({

    }),  
    beforeDestroy() {

    },
    created(){

    },
    mounted() {

    },
    methods: {
        enter(done) { 
            done() 
        },
        leave(done) { 
            done() 
        },
        onClick() { 
            this.$parent.is_welcome = false
            // this.$parent.is_playing = true
        },
    }
}
</script>

<style lang='stylus'>

@import '~@/commons/stylus/Media-queries'
@import '~@/config/Settings'

// .Welcome
//     position absolute
//     width 100vw
//     height 100vh
//     top 0
//     left 0
//     z-index 1000
//     display flex 
//     align-items center
//     justify-content center

//     &__container 
//         width 100%
//         max-width 600px
//         height 100%
//         display flex 
//         align-items center
//         justify-content center
//         flex-direction column
//         text-align center

//     &__title
//         margin-bottom 32px

//     &__button 
//         background #5b9b45
//         padding 4px 12px
//         margin-top 32px
//         cursor pointer

</style>